// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import Layout, { Container } from '../components/layout';
// import { apiurl } from '../config/config';
// import { getCookie } from '../config/webStorage';
// import BackHeader from '../components/backHeader';
// import { IoArrowBack, IoChevronBackSharp } from 'react-icons/io5';
// import { IoMdArrowRoundBack } from 'react-icons/io';
// import SearchContainer from '../components/searchContainer';

// function CustomerDetails() {
//     const { customerId } = useParams();
//     const token = getCookie('sctoken');
//     const [superadminInfo, setSuperadminInfo] = useState(null);
//     const [adminList, setAdminList] = useState([]);
//     const [selectedAdmin, setSelectedAdmin] = useState(null);
//     const [userList, setUserList] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [listLoading, setListLoading] = useState(false);
//     const [adminLoading, setAdminLoading] = useState(false);
//     const [userListLoading, setUserListLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [listError, setListError] = useState(null);
//     const [adminError, setAdminError] = useState(null);
//     const [userListError, setUserListError] = useState(null);
//     const [searchInput, setSearchInput] = useState("");


//     // Fetch superadmin details
//     useEffect(() => {
//         const fetchSuperadminInfo = async () => {
//             try {
//                 const response = await axios.get(
//                     `${apiurl}/api/whatsapp/user/getadminInfo?id=${customerId}`,
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );
//                 setSuperadminInfo(response.data.Super_admin);
//                 setLoading(false);
//             } catch (err) {
//                 setError('Failed to fetch admin info');
//                 setLoading(false);
//             }
//         };
//         fetchSuperadminInfo();
//     }, [customerId, token]);

//     // Fetch admin list
//     const fetchAdminList = async () => {
//         setListLoading(true);
//         setListError(null);
//         try {
//             const response = await axios.get(
//                 `${apiurl}/api/whatsapp/user/getadminlistofsuperadmin?id=${customerId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setAdminList(response.data.admin);
//             setListLoading(false);
//         } catch (err) {
//             setListError('Failed to fetch admin list');
//             setListLoading(false);
//         }
//     };

//     // Fetch selected admin details
//     const fetchAdminDetails = async (adminId) => {
//         setAdminLoading(true);
//         setAdminError(null);
//         setUserList([]);
//         try {
//             const response = await axios.get(
//                 `${apiurl}/api/whatsapp/user/getadminInfo?id=${adminId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setSelectedAdmin(response.data.Super_admin);
//             setAdminLoading(false);
//         } catch (err) {
//             setAdminError('Failed to fetch admin details');
//             setAdminLoading(false);
//         }
//     };

//     // Fetch user list
//     const fetchUserList = async (adminId) => {
//         setUserListLoading(true);
//         setUserListError(null);
//         try {
//             const response = await axios.get(
//                 `${apiurl}/api/whatsapp/user/getuserlistofadmin?id=${adminId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setUserList(response.data.users || []);
//             setUserListLoading(false);
//         } catch (err) {
//             setUserListError('Failed to fetch user list');
//             setUserListLoading(false);
//         }
//     };

//     // Back button handler
//     const handleBack = () => {
//         setSelectedAdmin(null);
//         setUserList([]);
//         setAdminError(null);
//         setUserListError(null);
//     };

//     if (loading) return <Layout><div className="text-center text-text-primary">Loading...</div></Layout>;
//     if (error) return <Layout><div className="text-center text-error">{error}</div></Layout>;

//     return (
//         <Layout>

//             <Container>
//                 <div className="border bg-white h-full w-full px-2 py-2 overflow-y-scroll custom-scrollbar">
//                     {/* Main Client Details View */}
//                     {!selectedAdmin && (
//                         <div className='p-2'>
//                             <div className='mb-5'>
//                                 <BackHeader
//                                     title={
//                                         <span className="flex flex-col md:flex-row items-center">
//                                             Client Details
//                                         </span>
//                                     }
//                                     // rightSide={
//                                     //     <div className="flex gap-2 items-center">
//                                     //         <div className="block md:hidden">
//                                     //             <Link to="/clients/add">
//                                     //                 <ButtonContainer icon={<IoAddOutline />} />
//                                     //             </Link>
//                                     //         </div>
//                                     //         <div className="hidden md:block">
//                                     //             <Link to="/newClient">
//                                     //                 <ButtonContainer icon={<IoAddOutline />}>
//                                     //                     Add Client
//                                     //                 </ButtonContainer>
//                                     //             </Link>
//                                     //         </div>
//                                     //         <div className="hidden md:flex">
//                                     //             <SearchContainer
//                                     //                 value={searchInput}
//                                     //                 placeholder={"Search Clients..."}
//                                     //                 onChange={(e) => setSearchInput(e.target.value)}
//                                     //             />
//                                     //         </div>
//                                     //     </div>
//                                     // }
//                                     backButton={true}
//                                     link={"/clients"}
//                                 />
//                             </div>

//                             {superadminInfo && (
//                                 // <div className="relative bg-gradient-to-br from-accent to-light-secondary rounded-2xl p-8 mb-8 shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
//                                 <div className="border border-light-primary rounded-2xl p-8 mb-8">
//                                     {/* Subtle overlay for better text contrast */}
//                                     {/* <div className="absolute inset-0 bg-white bg-opacity-80"></div> */}
//                                     {/* Content */}
//                                     <div className="relative z-10">
//                                         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//                                             {/* Left Column */}
//                                             <div className="space-y-5 text-left">
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Name</span>
//                                                     <p className="text-text-primary text-lg font-medium">{superadminInfo.name}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Email</span>
//                                                     <p className="text-text-primary text-lg font-medium">{superadminInfo.email}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Phone</span>
//                                                     <p className="text-text-primary text-lg font-medium">{superadminInfo.phone}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Tenant</span>
//                                                     <p className="text-text-primary text-lg font-medium">{superadminInfo.tenant.tenantName}</p>
//                                                 </div>
//                                             </div>

//                                             {/* Right Column */}
//                                             <div className="space-y-5 text-left">
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">User Type</span>
//                                                     <p className="text-text-primary text-lg font-medium">{superadminInfo.userType}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Status</span>
//                                                     <p className="text-text-primary text-lg font-medium">
//                                                         <span
//                                                             className={`inline-flex items-center  py-1 rounded-full text-lg font-medium ${superadminInfo.status === 'active'
//                                                                 ? 'text-success'
//                                                                 : 'text-error'
//                                                                 }`}
//                                                         >
//                                                             {superadminInfo.status}
//                                                         </span>
//                                                     </p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Wallet</span>
//                                                     <p className="text-text-primary text-lg font-medium">{superadminInfo.wallet}</p>
//                                                 </div>
//                                                 <div className="flex gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Address</span>
//                                                     <div className="rounded-sm">
//                                                         <p className="text-text-secondary text-base">{superadminInfo.address.name}</p>
//                                                         <p className="text-text-secondary text-base">{superadminInfo.address.line1}</p>
//                                                         {superadminInfo.address.line2 && (
//                                                             <p className="text-text-secondary text-base">{superadminInfo.address.line2}</p>
//                                                         )}
//                                                         <p className="text-text-secondary text-base">
//                                                             {superadminInfo.address.city}, {superadminInfo.address.province}{' '}
//                                                             {superadminInfo.address.zip}, {superadminInfo.address.country}
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                             <div className='flex justify-end'>
//                                 <button
//                                     onClick={fetchAdminList}
//                                     disabled={listLoading}
//                                     className={`w-full md:w-auto px-4 py-2 rounded-sm text-white font-medium transition-colors
//                                 ${listLoading ? 'bg-primary cursor-not-allowed opacity-70' : 'bg-primary hover:bg-light-primary'}`}
//                                 >
//                                     {listLoading ? 'Loading...' : 'Show Admin List'}
//                                 </button>
//                             </div>

//                             {listError && <p className="text-error mt-4">{listError}</p>}

//                             {adminList.length > 0 && (
//                                 <div className="mt-6 bg-white shadow rounded-sm overflow-hidden">
//                                     <div className='flex flex-col md:flex-row justify-between gap-2 md:items-center p-4'>
//                                         <h3 className="text-lg font-semibold text-primary">Admin List</h3>
//                                         <div className="">
//                                             <SearchContainer
//                                                 value={searchInput}
//                                                 placeholder={"Search Admins..."}
//                                                 onChange={(e) => setSearchInput(e.target.value)}
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="max-h-80 overflow-y-auto">
//                                         <table className="w-full">
//                                             <thead className="bg-accent sticky top-0">
//                                                 <tr>
//                                                     {['Name', 'Email', 'Phone', 'Tenant', 'Status', 'Action'].map((header) => (
//                                                         <th key={header} className="px-4 py-2 text-text-primary font-medium border-b border-light-secondary">
//                                                             {header}
//                                                         </th>
//                                                     ))}
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {adminList.map((admin) => (
//                                                     <tr key={admin.id} className="">
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{admin.name}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{admin.email}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{admin.phone || 'N/A'}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{admin.tenant.tenantName}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{admin.status}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">
//                                                             <button
//                                                                 onClick={() => fetchAdminDetails(admin.id)}
//                                                                 className="px-3 py-1 text-light-primary"
//                                                             >
//                                                                 View
//                                                             </button>
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     {/* Admin Details View */}
//                     {selectedAdmin && (
//                         <div className='p-2'>
//                             <div className="flex items-center gap-5 mb-6">
//                                 <button
//                                     onClick={handleBack}
//                                     className="px-1 py-1 text-xs border border-secondary hover:border-primary text-primary rounded-sm transition-colors flex items-center gap-2"
//                                 >
//                                     <IoMdArrowRoundBack className="text-primary text-xs md:text-sm" />
//                                 </button>
//                                 <h2 className="text-2xl font-bold text-primary">Admin Details of superadmin :- {superadminInfo?.name}</h2>
//                             </div>

//                             {adminLoading && <p className="text-text-primary mt-4">Loading admin details...</p>}
//                             {adminError && <p className="text-error mt-4">{adminError}</p>}

//                             {!adminLoading && !adminError && (
//                                 <div className="border border-light-primary rounded-2xl p-8 mb-8">
//                                     {/* Subtle overlay for better text contrast */}
//                                     {/* <div className="absolute inset-0 bg-white bg-opacity-80"></div> */}
//                                     {/* Content */}
//                                     <div className="relative z-10">
//                                         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//                                             {/* Left Column */}
//                                             <div className="space-y-5 text-left">
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Name</span>
//                                                     <p className="text-text-primary text-lg font-medium">{selectedAdmin.name}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Email</span>
//                                                     <p className="text-text-primary text-lg font-medium">{selectedAdmin.email}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Phone</span>
//                                                     <p className="text-text-primary text-lg font-medium">{selectedAdmin.phone || 'N/A'}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Tenant</span>
//                                                     <p className="text-text-primary text-lg font-medium">{selectedAdmin.tenant.tenantName}</p>
//                                                 </div>
//                                             </div>

//                                             {/* Right Column */}
//                                             <div className="space-y-5 text-left">
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">User Type</span>
//                                                     <p className="text-text-primary text-lg font-medium">{selectedAdmin.userType}</p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Status</span>
//                                                     <p className="text-text-primary text-lg font-medium">
//                                                         <span
//                                                             className={`text-lg font-medium ${selectedAdmin.status === 'active'
//                                                                 ? 'text-success'
//                                                                 : 'text-error'
//                                                                 }`}
//                                                         >
//                                                             {selectedAdmin.status}
//                                                         </span>
//                                                     </p>
//                                                 </div>
//                                                 <div className="flex items-center gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Wallet</span>
//                                                     <p className="text-text-primary text-lg font-medium">{selectedAdmin.wallet}</p>
//                                                 </div>
//                                                 <div className="flex gap-4">
//                                                     <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Address</span>
//                                                     <div className="space-y-2">
//                                                         <p className="text-text-secondary text-base">{selectedAdmin.address.name}</p>
//                                                         <p className="text-text-secondary text-base">{selectedAdmin.address.line1}</p>
//                                                         {selectedAdmin.address.line2 && (
//                                                             <p className="text-text-secondary text-base">{selectedAdmin.address.line2}</p>
//                                                         )}
//                                                         <p className="text-text-secondary text-base">
//                                                             {selectedAdmin.address.city}, {selectedAdmin.address.province}{' '}
//                                                             {selectedAdmin.address.zip}, {selectedAdmin.address.country}
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                             <div className='flex justify-end'>
//                                 <button
//                                     onClick={() => fetchUserList(selectedAdmin.id)}
//                                     disabled={userListLoading}
//                                     className={`w-full md:w-auto px-4 py-2 rounded-sm text-white font-medium transition-colors
//                                         ${userListLoading ? 'bg-primary cursor-not-allowed opacity-70' : 'bg-primary hover:bg-light-primary'}`}
//                                 >
//                                     {userListLoading ? 'Loading...' : 'Show User List'}
//                                 </button>
//                             </div>

//                             {userListError && <p className="text-error mt-4">{userListError}</p>}

//                             {userList.length > 0 && (
//                                 <div className="mt-6">
//                                     <h4 className="text-md font-semibold text-primary mb-2">User List</h4>
//                                     <div className="max-h-80 overflow-y-auto">
//                                         <table className="w-full">
//                                             <thead className="bg-accent sticky top-0">
//                                                 <tr>
//                                                     {['Name', 'Email', 'Phone', 'Status'].map((header) => (
//                                                         <th key={header} className="px-4 py-2 text-left text-text-primary font-medium border-b border-light-secondary">
//                                                             {header}
//                                                         </th>
//                                                     ))}
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {userList.map((user) => (
//                                                     <tr key={user.id} className="hover:bg-accent transition-colors">
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{user.name}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{user.email}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{user.phone || 'N/A'}</td>
//                                                         <td className="px-4 py-2 border-b border-light-secondary">{user.status}</td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </Container>
//         </Layout>
//     );
// }

// export default CustomerDetails;






































import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Layout, { Container } from '../components/layout';
import { apiurl } from '../config/config';
import { getCookie } from '../config/webStorage';
import BackHeader from '../components/backHeader';
import SearchContainer from '../components/searchContainer';

function CustomerDetails() {
    const { customerId } = useParams();
    const token = getCookie('sctoken');
    const [adminInfo, setAdminInfo] = useState(null);
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userListLoading, setUserListLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userListError, setUserListError] = useState(null);
    const [isUserListOpen, setIsUserListOpen] = useState(false);
    const [searchInput, setSearchInput] = useState('');

    // Fetch admin details
    useEffect(() => {
        const fetchAdminInfo = async () => {
            try {
                const response = await axios.get(
                    `${apiurl}/api/whatsapp/user/getadminInfo?id=${customerId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setAdminInfo(response.data.Super_admin); // Assuming API returns admin data in Super_admin field; adjust if needed
                setLoading(false);
            } catch (err) {
                setError('Failed to fetch admin info');
                setLoading(false);
            }
        };
        fetchAdminInfo();
    }, [customerId, token]);

    // Fetch user list
    const fetchUserList = async () => {
        setUserListLoading(true);
        setUserListError(null);
        try {
            const response = await axios.get(
                `${apiurl}/api/whatsapp/user/getuserlistofadmin?id=${customerId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setUserList(response.data.users || []);
            setUserListLoading(false);
            setIsUserListOpen(true); // Open popup
        } catch (err) {
            setUserListError('Failed to fetch user list');
            setUserListLoading(false);
        }
    };

    // Close popup
    const closeUserList = () => {
        setIsUserListOpen(false);
        setUserList([]);
        setUserListError(null);
    };

    if (loading) return <Layout><div className="text-center text-text-primary">Loading...</div></Layout>;
    if (error) return <Layout><div className="text-center text-error">{error}</div></Layout>;

    return (
        <Layout>
            <Container>
                <div className="border bg-white h-full w-full px-2 py-2 overflow-y-scroll custom-scrollbar">
                    <div className="p-2">
                        <div className="mb-5">
                            <BackHeader
                                title={<span className="flex flex-col md:flex-row items-center">Customer Details</span>}
                                backButton={true}
                                link="/customers"
                            />
                        </div>

                        {adminInfo && (
                            <div className="relative border border-light-primary rounded-2xl p-8 mb-8">
                                <div className="relative z-10">
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                        {/* Left Column */}
                                        <div className="space-y-5 text-left">
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Name</span>
                                                <p className="text-text-primary text-lg font-medium">{adminInfo.name}</p>
                                            </div>
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Email</span>
                                                <p className="text-text-primary text-lg font-medium">{adminInfo.email}</p>
                                            </div>
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Phone</span>
                                                <p className="text-text-primary text-lg font-medium">{adminInfo.phone || 'N/A'}</p>
                                            </div>
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Tenant</span>
                                                <p className="text-text-primary text-lg font-medium">{adminInfo.tenant.tenantName}</p>
                                            </div>
                                        </div>

                                        {/* Right Column */}
                                        <div className="space-y-5 text-left">
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">User Type</span>
                                                <p className="text-text-primary text-lg font-medium">{adminInfo.userType}</p>
                                            </div>
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Status</span>
                                                <p className="text-text-primary text-lg font-medium">
                                                    <span
                                                        className={`text-lg font-medium ${
                                                            adminInfo.status === 'active'
                                                                ? 'text-success'
                                                                : 'text-error'
                                                        }`}
                                                    >
                                                        {adminInfo.status}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="flex items-center gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Wallet</span>
                                                <p className="text-text-primary text-lg font-medium">{adminInfo.wallet}</p>
                                            </div>
                                            <div className="flex gap-4">
                                                <span className="text-light-primary font-semibold text-sm uppercase tracking-wide w-28">Address</span>
                                                <div className="space-y-2">
                                                    <p className="text-text-secondary text-base">{adminInfo.address.name}</p>
                                                    <p className="text-text-secondary text-base">{adminInfo.address.line1}</p>
                                                    {adminInfo.address.line2 && (
                                                        <p className="text-text-secondary text-base">{adminInfo.address.line2}</p>
                                                    )}
                                                    <p className="text-text-secondary text-base">
                                                        {adminInfo.address.city}, {adminInfo.address.province}{' '}
                                                        {adminInfo.address.zip}, {adminInfo.address.country}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="flex justify-end">
                            <button
                                onClick={fetchUserList}
                                disabled={userListLoading}
                                className={`w-full md:w-auto px-4 py-2 rounded-sm text-white font-medium transition-colors
                                    ${userListLoading ? 'bg-primary cursor-not-allowed opacity-70' : 'bg-primary hover:bg-light-primary'}`}
                            >
                                {userListLoading ? 'Loading...' : 'Show User List'}
                            </button>
                        </div>
                    </div>
                </div>

                {/* User List Popup */}
                {isUserListOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-xl p-6 w-full max-w-4xl max-h-[80vh] overflow-y-auto shadow-xl">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-xl font-semibold text-primary">User List</h3>
                                <button
                                    onClick={closeUserList}
                                    className="text-text-secondary hover:text-primary transition-colors"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>

                            {userListError && <p className="text-error mb-4">{userListError}</p>}

                            {userList.length > 0 ? (
                                <>
                                    <div className="mb-4">
                                        <SearchContainer
                                            value={searchInput}
                                            placeholder="Search Users..."
                                            onChange={(e) => setSearchInput(e.target.value)}
                                        />
                                    </div>
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="bg-accent sticky top-0">
                                                <tr>
                                                    {['Name', 'Email', 'Phone', 'Status'].map((header) => (
                                                        <th key={header} className="px-4 py-2 text-left text-text-primary font-medium border-b border-light-secondary">
                                                            {header}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {userList
                                                    .filter((user) =>
                                                        user.name.toLowerCase().includes(searchInput.toLowerCase()) ||
                                                        user.email.toLowerCase().includes(searchInput.toLowerCase())
                                                    )
                                                    .map((user) => (
                                                        <tr key={user.id} className="hover:bg-accent transition-colors">
                                                            <td className="px-4 py-2 border-b border-light-secondary">{user.name}</td>
                                                            <td className="px-4 py-2 border-b border-light-secondary">{user.email}</td>
                                                            <td className="px-4 py-2 border-b border-light-secondary">{user.phone || 'N/A'}</td>
                                                            <td className="px-4 py-2 border-b border-light-secondary">
                                                                <span
                                                                    className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                                                                        user.status === 'active'
                                                                            ? 'bg-success bg-opacity-20 text-success'
                                                                            : 'bg-error bg-opacity-20 text-error'
                                                                    }`}
                                                                >
                                                                    {user.status}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <p className="text-text-secondary">No users found.</p>
                            )}
                        </div>
                    </div>
                )}
            </Container>
        </Layout>
    );
}

export default CustomerDetails;